/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Model_NcsColorGet } from '../models/Model_NcsColorGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NcsColorService {
    /**
     * @returns Model_NcsColorGet Success
     * @throws ApiError
     */
    public static getApiV1NcsColors(): CancelablePromise<Array<Model_NcsColorGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ncsColors',
        });
    }
}
